<template>
  <div>
    <v-text-field
      ref="first"
      label="Gatuadress/boxadress"
      :value="value.address"
      :name="prefix + 'Address'"
      :append-icon="appendIcon"
      :rules="rules.address"
      @input="updateAddress('address', $event)"
      @click:append="$emit('click:append', $event)"
    ></v-text-field>

    <v-row dense>
      <v-col cols="5" class="pt-0 pb-0">
        <v-text-field
          label="Postnr"
          :value="value.postalCode"
          :name="prefix + 'PostalCode'"
          :rules="rules.postalCode"
          @input="updateAddress('postalCode', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="7" class="pt-0 pb-0">
        <v-text-field
          label="Ort"
          :value="value.city"
          :name="prefix + 'City'"
          :rules="rules.city"
          @input="updateAddress('city', $event)"
        >
          <template v-slot:append>
            <v-btn v-if="countryIcon" icon x-small @click="showCountry = !showCountry">
              <v-icon v-text="countryIcon"></v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row dense v-if="showCountry">
      <v-col cols="4">
        <v-text-field
          label="Region"
          :value="value.region"
          :name="prefix + 'Region'"
          @input="updateAddress('region', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="8">
        <v-select
          label="Land"
          :value="value.country"
          :name="prefix + 'Country'"
          :items="countryOptions"
          item-value="value"
          item-text="title"
          clearable
          @change="updateAddress('country', $event)"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { countries } from '../../utils'

export default {
  name: 'CrmAddressFields',
  props: {
    value: {
      type: Object,
      default: () => ({
        address: '',
        postalCode: '',
        city: ''
      })
    },
    prefix: {
      type: String,
      default: ''
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    appendIcon: {
      type: String
    },
    international: {
      type: Boolean
    }
  },
  data () {
    return {
      showCountry: !!(this.value && (this.value.country || this.value.region))
    }
  },
  computed: {
    countryOptions () {
      return countries
    },
    countryIcon () {
      return this.international ? 'mdi-earth' : null
    }
  },
  methods: {
    countries () {
      return countries
    },
    updateAddress (field, input) {
      const payload = { ...this.value }
      payload[field] = input === '' ? null : input
      this.$emit('input', payload)
    }
  }
}
</script>
